<template>
    <li class="timeline-item" v-if="itemType == 'timeline-item'">
        <div v-bind:class="`timeline-badge ${item.status.type}`">
            <i class="fa fa-map-pin"></i>
        </div>
        <div class="timeline-panel">
            <div class="timeline-heading">
                <h4 class="timeline-title">{{ item.location.name }}</h4>
                <div class="timeline-panel-controls">
                    <div class="timestamp">
                        <small class="text-muted">{{ item.created_at }}</small>
                    </div>
                </div>
            </div>
            <div class="timeline-body">
                {{ item?.escorter?.first_name }}
            </div>
        </div>
    </li>
    <li class="timeline-item" v-else-if="itemType == 'tracking-timeline-item'">
        <div v-bind:class="`timeline-badge ${getStatusType()}`">
            <i class="fa fa-truck"></i>
        </div>
        <div class="timeline-panel">
            <div class="timeline-heading trip-timeline-entry__head">
                <div class="trip-timeline-entry__title-block">
                    <span class="trip-timeline-entry__type">{{ getLocationTypeLabel() }}</span>
                    <h5 class="timeline-title trip-timeline-entry__title">{{ getLocationName() }}</h5>
                </div>

                <div class="timeline-panel-controls trip-timeline-entry__controls">
                    <div class="timestamp trip-timeline-entry__timestamp">
                        <span>{{ item.moment ? formatDateTime(item.moment) : '---' }}</span>
                    </div>
                </div>
            </div>

            <div class="timeline-body trip-timeline-entry__body">
                <div class="trip-timeline-entry__fact-grid">
                    <div class="trip-timeline-entry__fact">
                        <span class="trip-timeline-entry__fact-label">{{ $t('trip_status') }}</span>
                        <span class="trip-timeline-entry__status-chip" :class="`trip-timeline-entry__status-chip--${getStatusType()}`">
                            {{ getStatusLabel() }}
                        </span>
                    </div>

                    <div class="trip-timeline-entry__fact trip-timeline-entry__fact--person">
                        <span class="trip-timeline-entry__fact-label">{{ $t('escorter') }}</span>
                        <div class="trip-timeline-entry__person">
                            <span class="trip-timeline-entry__avatar trip-timeline-entry__avatar--escorter">
                                <img v-if="getEscorterAvatarUrl()" :src="getEscorterAvatarUrl()" :alt="getEscorterName()" />
                                <span v-else>{{ getInitials(getEscorterName()) }}</span>
                            </span>
                            <span class="trip-timeline-entry__fact-value">{{ getEscorterName() }}</span>
                        </div>
                    </div>
                </div>

                <div v-if="item?.escorter?.phone" class="trip-timeline-entry__contact-row">
                    <a :href="`tel:${item.escorter.phone}`" class="trip-timeline-entry__contact-chip">
                        {{ item.escorter.phone }}
                    </a>
                </div>

                <div v-if="item.comment" class="trip-timeline-entry__comment">
                    {{ item.comment }}
                </div>

                <div class="trip-timeline-entry__footer">
                    <div class="trip-timeline-entry__author-wrap">
                        <span class="trip-timeline-entry__avatar trip-timeline-entry__avatar--user">
                            <img v-if="getUserAvatarUrl()" :src="getUserAvatarUrl()" :alt="getUserName()" />
                            <span v-else>{{ getInitials(getUserName()) }}</span>
                        </span>

                        <div class="trip-timeline-entry__author-copy">
                            <span class="trip-timeline-entry__author">
                                <strong>{{ `${$t('created_by')}:` }}</strong>
                                {{ getUserName() }}
                            </span>
                            <a v-if="item?.user?.email" :href="`mailto:${item.user.email}`" class="trip-timeline-entry__email">
                                {{ item.user.email }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </li>
</template>

<script>
import { formatDateToLocal } from '../../../app/Helpers/Helpers';

export default {
    name: 'TimelineItem',
    props: {
        item: {
            type: Object,
            required: true,
        },
        itemType: {
            type: String,
            default: 'timeline-item',
        }
    },
    data() {
        return {

        }
    },
    methods: {
        formatDateTime(date) {
            const dt = date.split(' ')[0];
            const tm = date.split(' ')[1];
            return `${formatDateToLocal(dt)} ${tm}`;
        },
        getLocationTypeLabel() {
            return this.item?.location?.location_type?.name || this.$t('location');
        },
        getLocationName() {
            return this.item?.location?.name || '---';
        },
        getStatusType() {
            return this.item?.status?.type || 'secondary';
        },
        getStatusLabel() {
            return this.item?.status?.name || '---';
        },
        getEscorterAvatarUrl() {
            return this.item?.escorter?.photo?.full_url || '';
        },
        getEscorterName() {
            return this.item?.escorter?.first_name ? `${this.item?.escorter?.first_name} ${this.item?.escorter?.last_name} ${this.item?.escorter?.middle_name}` : '-';
        },
        getUserAvatarUrl() {
            return this.item?.user?.profile_picture?.full_url || '';
        },
        getUserName() {
            const firstName = this.item?.user?.first_name;
            const lastName = this.item?.user?.last_name;

            return [firstName, lastName].filter(Boolean).join(' ') || '---';
        },
        getInitials(value) {
            return `${value || ''}`
                .split(' ')
                .filter(Boolean)
                .slice(0, 2)
                .map((part) => part.charAt(0))
                .join('')
                .toUpperCase() || '--';
        }
    }
}
</script>
